import React, { useEffect, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Stack, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getHomeSlideOnly } from '../../../Redux/HomeSlideRedux.js';

const staticSlides = [
  {
    _id: 'static1',
    title: 'Static Slide 1',
    description: 'This is the first static slide.',
    images: [{ image: '/static-image1.jpg' }],
  },
  {
    _id: 'static2',
    title: 'Static Slide 2',
    description: 'This is the second static slide.',
    images: [{ image: '/static-image2.jpg' }],
  },
];

const getImageUrl = (image) => {
  if (!image) return "/placeholder-image.png";
  if (typeof image === "string") {
    if (image.startsWith("blob:")) return image;
    if (image.startsWith("http")) return image;
    return `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_HOME_SLIDE_PATH}/${image}`;
  }
  return "/placeholder-image.png";
};


function CarouselItem({ item }) {
  const imageUrl = getImageUrl(item.images?.[0]);
  return (
    <Paper
      style={{
        position: 'relative',
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        height: '600px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        }}
      ></div>
      <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <h1>{item.title}</h1>
        <h5>{item.description}</h5>
      </div>
    </Paper>
  );
}

function CarouselMain() {
  const dispatch = useDispatch();
  const { allHomeSlidesOnly } = useSelector((state) => state.homeSlideRedux);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      setLoading(true);
      await dispatch(getHomeSlideOnly());
      setLoading(false);
    };

    fetchSlides();
  }, [dispatch]);

  if (loading) {
    return (
      <Stack
        className='mx-4'
        spacing={1}
      >
        <Skeleton
          variant='rounded'
          height={400}
        />
        {/* <Skeleton variant="text" sx={{ fontSize: '1.1rem' }} />
             <Skeleton  variant="rounded"  height={200} /> */}
      </Stack>
      // <div
      //   style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}
      // >
      //   <CircularProgress color='success' />
      // </div>
    );
  }

  const slidesToShow =
    allHomeSlidesOnly && allHomeSlidesOnly.length > 0
      ? allHomeSlidesOnly
      : staticSlides;

  return (
    <Carousel
      interval={5000}
      indicators={false}
    >
      {slidesToShow.map((slide) => (
        <CarouselItem
          key={slide._id}
          item={slide}
        />
      ))}
    </Carousel>
  );
}

export default CarouselMain;
